
















import Vue from "vue";

export default Vue.component("SHCartCardSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
